import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data"]
const _hoisted_2 = { class: "order-details-inner" }
const _hoisted_3 = { class: "views-nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "order-details-card-list" }
const _hoisted_6 = {
  key: 2,
  class: "event-details"
}
const _hoisted_7 = { class: "event-metadata" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 3,
  class: "event-details"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_product_list = _resolveComponent("product-list")!
  const _component_address_editor = _resolveComponent("address-editor")!
  const _component_operational_data = _resolveComponent("operational-data")!
  const _component_order_error_details = _resolveComponent("order-error-details")!
  const _component_order_fulfillment_details = _resolveComponent("order-fulfillment-details")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_order_event_timeline = _resolveComponent("order-event-timeline")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-item", _ctx.mode]),
    "data-cy": "order-item"
  }, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showingDocs,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showingDocs) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"height":"100vh","width":"100vw"} }, {
          default: _withCtx(() => [
            (_ctx.docData?.length)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  style: {"height":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docData, (doc) => {
                      return (_openBlock(), _createElementBlock("object", {
                        data: `data:application/pdf;base64,${doc}`,
                        type: "application/pdf",
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, _hoisted_1))
                    }), 256))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.payload || !_ctx.loaded)
        ? _renderSlot(_ctx.$slots, "placeholder", {
            key: 0,
            payload: _ctx.payload,
            request: _ctx.requestHandler
          }, () => [
            _createVNode(_component_spinner, {
              scale: 0.5,
              visible: true,
              style: {"margin":"0 auto","width":"50px"}
            })
          ], true)
        : _renderSlot(_ctx.$slots, "content", {
            key: 1,
            payload: _ctx.payload,
            request: _ctx.requestHandler
          }, () => [
            _renderSlot(_ctx.$slots, "nav", {
              payload: _ctx.payload,
              request: _ctx.requestHandler,
              active: _ctx.active,
              toggleActive: _ctx.toggleActive
            }, () => [
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views.filter(v => !(_ctx.payload?.sys?.draft && v === 'Events')), (view, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["views-nav--item", {active: _ctx.active === view}]),
                    onClick: ($event: any) => (_ctx.active = view),
                    "data-cy": "orderdetail-view-item"
                  }, _toDisplayString(view), 11, _hoisted_4))
                }), 256))
              ])
            ], true),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.active === _ctx.OrderDetailView.Products)
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["order-details-view order-details-view__view-products", {wideview: _ctx.itemView === 3 || _ctx.itemView === 1}]),
                    ref: "detailsContainer",
                    key: _ctx.active
                  }, [
                    _renderSlot(_ctx.$slots, "products", {
                      payload: _ctx.payload,
                      request: _ctx.requestHandler
                    }, () => [
                      _createVNode(_component_product_list, {
                        id: _ctx.payload.sys.id,
                        items: _ctx.products,
                        "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.products) = $event)),
                        packing: _ctx.packing,
                        "onUpdate:packing": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.packing) = $event)),
                        onReplaced: _ctx.emitProductsAndPackaging,
                        packed: _ctx.highlightPacked,
                        "onUpdate:packed": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.highlightPacked) = $event)),
                        "show-issues": _ctx.showIssues,
                        status: _ctx.payload.status,
                        readonly: _ctx.readonly,
                        collections: _ctx.collections,
                        "item-view": _ctx.itemView,
                        view: _ctx.productsView
                      }, null, 8, ["id", "items", "packing", "onReplaced", "packed", "show-issues", "status", "readonly", "collections", "item-view", "view"])
                    ], true),
                    (_ctx.itemView === 3 || _ctx.itemView === 1)
                      ? _renderSlot(_ctx.$slots, "address", {
                          key: 0,
                          payload: _ctx.payload,
                          request: _ctx.requestHandler
                        }, () => [
                          _createVNode(_component_address_editor, {
                            "model-value": _ctx.address,
                            request: _ctx.patchAddress,
                            id: _ctx.payload.sys.id,
                            class: _normalizeClass({wideview: _ctx.itemView === 3 || _ctx.itemView === 1})
                          }, null, 8, ["model-value", "request", "id", "class"])
                        ], true)
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.active === _ctx.OrderDetailView.Fulfillments)
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["order-details-view order-details-view__view-fulfillments", {wideview: _ctx.itemView === 3 || _ctx.itemView === 1}]),
                    ref: "detailsContainer",
                    key: _ctx.active
                  }, [
                    (_ctx.itemView === 2)
                      ? _renderSlot(_ctx.$slots, "address", {
                          key: 0,
                          payload: _ctx.payload,
                          request: _ctx.requestHandler
                        }, () => [
                          _createVNode(_component_address_editor, {
                            "model-value": _ctx.address,
                            request: _ctx.patchAddress,
                            id: _ctx.payload.sys.id
                          }, null, 8, ["model-value", "request", "id"])
                        ], true)
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "operational", {
                      payload: _ctx.payload,
                      request: _ctx.requestHandler
                    }, () => [
                      _createVNode(_component_operational_data, {
                        id: _ctx.payload.sys.id,
                        modelValue: _ctx.operationalData,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.operationalData) = $event)),
                        edit: _ctx.editingOperationalData,
                        "show-issues": _ctx.showIssues,
                        readonly: _ctx.readonly
                      }, null, 8, ["id", "modelValue", "edit", "show-issues", "readonly"])
                    ], true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.active === _ctx.OrderDetailView.Events)
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["order-details-view order-details-view_view-events", {wideview: _ctx.itemView === 3 || _ctx.itemView === 1}]),
                    ref: "detailsContainer",
                    key: _ctx.active
                  }, [
                    _renderSlot(_ctx.$slots, "events", {
                      payload: _ctx.payload,
                      request: _ctx.requestHandler
                    }, () => [
                      _createVNode(_component_order_event_timeline, {
                        id: _ctx.payload.sys.id
                      }, {
                        default: _withCtx(({ metadata }) => [
                          (metadata?.error || metadata?.failed || _ctx.meta?.name === 'ServiceErrror')
                            ? (_openBlock(), _createBlock(_component_order_error_details, {
                                key: 0,
                                order: _ctx.payload.sys.id,
                                meta: metadata
                              }, null, 8, ["order", "meta"]))
                            : (metadata?.fulfillment)
                              ? (_openBlock(), _createBlock(_component_order_fulfillment_details, {
                                  key: 1,
                                  order: _ctx.payload.sys.id,
                                  data: _ctx.findFulfillment(metadata.fulfillment)
                                }, null, 8, ["order", "data"]))
                              : metadata
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("dl", _hoisted_7, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metadata, (value, key) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          _createElementVNode("dt", null, _toDisplayString(key), 1),
                                          ((typeof value === 'object'))
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_8, [
                                                (Array.isArray(value) && value.every(v => typeof v === 'string'))
                                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                                      key: 0,
                                                      flat: "",
                                                      compact: "",
                                                      onClick: ($event: any) => (_ctx.showDocuments(value))
                                                    }, {
                                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                        _createTextVNode("Show Document")
                                                      ])),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : (_openBlock(), _createElementBlock("pre", _hoisted_9, _toDisplayString(value), 1))
                                              ]))
                                            : (_openBlock(), _createElementBlock("dd", _hoisted_10, _toDisplayString(typeof value === 'boolean' ? (value ? 'yes' : 'no') : value), 1))
                                        ], 64))
                                      }), 256))
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, "No details"))
                        ]),
                        _: 1
                      }, 8, ["id"])
                    ], true)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _renderSlot(_ctx.$slots, "actions", {
              payload: _ctx.payload,
              request: _ctx.requestHandler
            }, undefined, true)
          ], true)
    ])
  ], 2))
}